import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Header, Icon, Modal} from 'semantic-ui-react';

import {IncludeScript, Loading} from 'Common/Structure';

import './squareForm.scss';
import {toasterError} from 'helpers';

const SquareForm = props => {
  const [squareForm, setSquareForm] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const buildForm = async () => {
    if (!window.Square) return false;
    const payments = Square.payments(props.applicationId, props.locationId);
    const card = await payments.card();
    card.attach('#sq-card');
    setSquareForm(card);
    return true;
  };

  const handleOpenModal = async () => {
    setModalVisible(true);
    let retry = 20; // retry when window.Square is not ready yet.
    while (retry--) {
      const result = await buildForm();
      await new Promise(r => setTimeout(r, 500));
      if (result) return;
    }
    toasterError('Unable to load card information. Please try again');
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSquareForm(null);
  };

  const handleSubmit = async () => {
    if (!squareForm) return;
    const result = await squareForm.tokenize();
    if (result.status != 'OK') {
      return;
    }
    props.setNonce(result.token);
    handleCloseModal();
  };

  let sdkUrl = 'https://web.squarecdn.com/v1/square.js';
  if (props.applicationId.startsWith('sandbox')) {
    sdkUrl = 'https://sandbox.web.squarecdn.com/v1/square.js';
  }
  return (
    <IncludeScript id="square-js" src={sdkUrl}>
      <Modal
        closeIcon
        onClose={handleCloseModal}
        open={modalVisible}
        size="small"
        trigger={
          <div style={{textAlign: 'center'}}>
            <Button
              basic={props.nonce !== null}
              onClick={handleOpenModal}
              primary
              type="button"
            >
              Enter Credit Card{' '}
              {props.nonce && <Icon name="check" style={{marginLeft: 5}} />}
            </Button>
          </div>
        }
      >
        <Header>Card Information</Header>

        <Modal.Content>
          <Loading visible={!squareForm} style={{marginTop: '20px'}} />
          <div id="sq-form-container">
            <div id="sq-card" />
          </div>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={handleSubmit} primary type="button">
            Submit
          </Button>
        </Modal.Actions>
      </Modal>
    </IncludeScript>
  );
};

SquareForm.defaultProps = {
  nonce: null,
};

SquareForm.propTypes = {
  applicationId: PropTypes.string.isRequired,
  nonce: PropTypes.string,

  // functions
  setNonce: PropTypes.func.isRequired,
};

export default SquareForm;



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PaymentForm/SquareForm/index.js